import { State } from "@/store/modules/floatMenu/index";

const getShowFloatMenu = (state: State): boolean => {
  return state.showFloatMenu;
};

const getManageSpace = (state: State): boolean => {
  return state.manageSpace;
};

const getOpenProfile = (state: State): boolean => {
  return state.openProfile;
};

const getOpenProfileSocial = (state: State): boolean => {
  return state.openProfileSocial;
};

const getOpenEmojiSelector = (state: State): boolean => {
  return state.openEmojiSelector;
};

const getOpenConsoleMessage = (state: State): boolean => {
  return state.openConsoleMessage;
};

const getOpenConsoleMessageMultiSpace = (state: State): boolean => {
  return state.openConsoleMessageMultiSpace;
};

const getOpenHelpBot = (state: State): boolean => {
  return state.openHelpBot;
};

const getOpenReasonSelector = (state: State): boolean => {
  return state.openReasonSelector;
};

const getShowNextMaintenance = (state: State): boolean => {
  return state.showNextMaintennace;
};

const getTimeNextMaintenance = (state: State): string => {
  return state.timeNextMaintennace;
};

const getOpenCalendarModal = (state: State): boolean => {
  return state.openCalendarModal;
};

const getOpenChangeSpaceSelector = (state: State): boolean => {
  return state.openChageSpaceSelector;
};

export default {
  getManageSpace,
  getShowFloatMenu,
  getOpenProfile,
  getOpenEmojiSelector,
  getOpenConsoleMessage,
  getOpenHelpBot,
  getOpenReasonSelector,
  getShowNextMaintenance,
  getTimeNextMaintenance,
  getOpenConsoleMessageMultiSpace,
  getOpenCalendarModal,
  getOpenChangeSpaceSelector,
  getOpenProfileSocial,
};
